module.exports = __webpack_public_path__ + "static/RG_img-8990febd4d2db3d86b2d42f2460f9248.jpg";